import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import ConfirmationModal from 'components/core/ConfirmationModal';
import Common from 'helpers/intl-common';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { LD_PROJECT_TRASH_CAN_FLAG } from 'constants/featureFlags';

const messages = defineMessages({
  confirmMoveToTrash: {
    id: 'Photos.deletePhotosModal.confirmMoveToTrash',
    defaultMessage: 'Yes, Move to Trash',
    description: 'Confirmatory action button label',
  },
});

const DeletePhotosModal = ({ photoCount, onRequestClose, onDelete }) => {
  const intl = useIntl();
  const flags = useFlags();
  const isTrashCanEnabled = flags[LD_PROJECT_TRASH_CAN_FLAG];
  return (
    <ConfirmationModal
      confirmAction={onDelete}
      confirmLabel={
        isTrashCanEnabled
          ? intl.formatMessage(messages.confirmMoveToTrash)
          : intl.formatMessage(Common.confirmDelete)
      }
      cancelLabel={
        isTrashCanEnabled
          ? intl.formatMessage(Common.cancel)
          : intl.formatMessage(Common.cancelDelete)
      }
      message={
        isTrashCanEnabled ? (
          <>
            <strong>
              <FormattedMessage
                id="Photos.deletePhotosModal.confirmationMessageTrash"
                defaultMessage="Photos will be deleted 90 days after you move them to the Trash."
                description="message to the user asking them to confirm their current action"
              />
            </strong>
            &nbsp;
            <FormattedMessage
              id="Photos.deletePhotosModal.confirmationMessageTrashSecondary"
              defaultMessage="Users with Admin or Manager permissions can move them back to the project within 90 days."
              description="message to the user explaining how the project trash works"
            />
          </>
        ) : (
          <FormattedMessage
            id="Photos.deletePhotosModal.confirmationMessage"
            defaultMessage="Are you sure you want to delete {photos, plural, one {# photo} other {# photos}}?"
            values={{ photos: photoCount }}
            description="message to the user asking them to confirm their current action"
          />
        )
      }
      title={
        isTrashCanEnabled ? (
          <FormattedMessage
            id="Photos.deletePhotosModal.modalTitle"
            defaultMessage="Move {photos, plural, one {# Photo} other {# Photos}} to Trash?"
            values={{ photos: photoCount }}
            description="Move to trash confirm modal title"
          />
        ) : (
          <FormattedMessage
            id="Photos.deletePhotosModal.deletePhotos"
            defaultMessage="Delete Photos"
            description="section header"
          />
        )
      }
      onRequestClose={onRequestClose}
    />
  );
};

DeletePhotosModal.propTypes = {
  photoCount: PropTypes.number,
  onDelete: PropTypes.func,
  onRequestClose: PropTypes.func,
};

export default DeletePhotosModal;
